import SingleSlider from './_SingleSlider.js';
import { jsx } from 'react/jsx-runtime';
import useGlobals from '../../hooks/useGlobals.js';

var durationFormatter = function durationFormatter(value, siteId) {
  switch (siteId) {
    case 1:
    case 3:
    case 11:
    case 18:
      return "".concat(value, " tim");
    case 15:
      return "".concat(value, " t");
    default:
      return "".concat(value, " tim");
  }
};
var DurationSlider = function DurationSlider(_ref) {
  var uniqueId = _ref.uniqueId,
    max = _ref.max,
    min = _ref.min,
    onChangeComplete = _ref.onChangeComplete,
    step = _ref.step,
    value = _ref.value,
    valueLabel = _ref.valueLabel,
    hidden = _ref.hidden;
  var _useGlobals = useGlobals(),
    siteId = _useGlobals.siteId;
  if (typeof onChangeComplete !== 'function' || typeof min !== 'number' || typeof max !== 'number' || typeof value !== 'number' || typeof max === 'number' && typeof min === 'number' && max < min) {
    return false;
  }
  return /*#__PURE__*/jsx(SingleSlider, {
    uniqueId: uniqueId,
    min: min,
    max: max,
    step: step,
    value: value,
    format: function format(v) {
      return durationFormatter(v, siteId);
    },
    valueLabel: valueLabel,
    onChangeComplete: onChangeComplete,
    hidden: hidden
  });
};
DurationSlider.defaultProps = {
  uniqueId: '',
  step: 1,
  valueLabel: '',
  hidden: false
};
var DurationSlider$1 = DurationSlider;

export { DurationSlider$1 as default };
//# sourceMappingURL=DurationSlider.js.map
